export default __webpack_public_path__ + "./images/bi.1f79bab0.png";